<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-5"></a>
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="toc-fm11"><a href="#/xhtml/005_FM1">Setting the scene</a></h2>
<h2 class="toc-fm"><span class="bold">Buses along The South West Coast Path:</span></h2>
<h2 class="toc-fm1"><a href="#/xhtml/006_Chapter_1"><span class="note01">1.</span> Minehead to Ilfracombe</a></h2>
<h2 class="toc-fm1"><span href="#/xhtml/007_Chapter_2" title="Link target outside of Sample"><span class="note01">2.</span> Ilfracombe to Boscastle</span></h2>
<h2 class="toc-fm1"><span href="#/xhtml/008_Chapter_3" title="Link target outside of Sample"><span class="note01">3.</span> Boscastle to Newquay</span></h2>
<h2 class="toc-fm1"><span href="#/xhtml/009_Chapter_4" title="Link target outside of Sample"><span class="note01">4.</span> Newquay to St Just</span></h2>
<h2 class="toc-fm1"><span href="#/xhtml/010_Chapter_5" title="Link target outside of Sample"><span class="note01">5.</span> St Just to Falmouth</span></h2>
<h2 class="toc-fm1"><span href="#/xhtml/011_Chapter_6" title="Link target outside of Sample"><span class="note01">6.</span> Falmouth to Plymouth (Jennycliff Bay)</span></h2>
<h2 class="toc-fm1"><span href="#/xhtml/012_Chapter_7" title="Link target outside of Sample"><span class="note01">7.</span> Plymouth (Jennycliff Bay) to Paignton</span></h2>
<h2 class="toc-fm1"><span href="#/xhtml/013_Chapter_8" title="Link target outside of Sample"><span class="note01">8.</span> Paignton to Seaton</span></h2>
<h2 class="toc-fm1"><span href="#/xhtml/014_Chapter_9" title="Link target outside of Sample"><span class="note01">9.</span> Seaton to South Haven Poin</span></h2>
<div class="img_container">
<img alt="image" src="images/5-00.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?33b43ede